var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.previewStyle)},[_c('h1',{staticClass:"action-form-preview-title"},[_vm._v(_vm._s(_vm.previewTitle))]),(_vm.fieldsToDisplay)?_c('kanban-card',{attrs:{"fieldsToDisplay":_vm.fieldsToDisplay,"card":_vm.data,"readOnly":"","showTitles":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }